export const GET_ADMIN_INTEGRATION_LOGS = "GET_ADMIN_INTEGRATION_LOGS"
export const GET_ADMIN_INTEGRATION_LOGS_SUCCESS = "GET_ADMIN_INTEGRATION_LOGS_SUCCESS"
export const GET_ADMIN_INTEGRATION_LOGS_ERROR = "GET_ADMIN_INTEGRATION_LOGS_ERROR"